import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import NewNavBar from "../../NavBar/Navbar";

import { withRouter } from "react-router";
import CompareAssesments from "./Compare-Assessment";
import Navbar from "../../../../_components/common/Navbar";


const calcWidth = window.innerWidth;
export class CompareAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[1].id,
      sidebarOpen: false,
      enableNotification: false,
      assessmentDetails: null,
      userId: "",
      downloadReportDropdown: [],
      devPlan: null,
      devPlanList: [],
      checkMultiRater: null,
      dataloader: null,
      collapseID: null,
    };
  }
  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  /* handle api calls */
  componentDidMount() {
    const id = this.props.match.params.id;
    const participant__id = this.props.match.params.participant__id;



  }

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };




  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };




  render() {
    const userType = localStorage.getItem("usertype");

    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin")  ? (
        <Navbar />
      ) : (
        <NewNavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
        />
      )}
        <ResponsiveSidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />
        <Sidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
        />
        <CompareAssesments />

      </div>
    );
  }
}

export default withRouter(CompareAssessment);



// WEBPACK FOOTER //
// ./src/new/Components/Reports/CompareAssessment/index.jsx